import axios from 'axios';

export interface AnalyticsEventPayload {
  event_name: string;
  event_time: string;
  source?: string;
  page_path?: string;
  page_title?: string;
  page_name?: string;
  anonymous_id?: string;
  session_id?: string;
  tenant_uuid?: string;
  workspace_uuid?: string;
  params_json?: string;
  /** 客户端 GA4 gtag.js 是否已加载成功，用于后端去重决策 */
  ga4_client_active?: boolean;
  /** 环境标识：production / bd / staging / development */
  env?: string;
}

interface ReportEventsResponse {
  accepted: number;
  dropped: number;
}

export const reportEvents = (events: AnalyticsEventPayload[]) => {
  return axios.post<ReportEventsResponse>('/api/console/analytics/v1/events', {
    events,
  });
};
